
import { useState, useMemo } from 'react';
import { Loan } from '../types/loans';

interface UseLoanFiltersProps {
  loans: Loan[];
}

interface UseLoanFiltersReturn {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  statusFilter: string;
  setStatusFilter: (status: string) => void;
  typeFilter: string;
  setTypeFilter: (type: string) => void;
  viewType: "active" | "past";
  setViewType: (type: "active" | "past") => void;
  filteredLoans: Loan[];
}

export const useLoanFilters = ({ loans }: UseLoanFiltersProps): UseLoanFiltersReturn => {
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [typeFilter, setTypeFilter] = useState("all");
  const [viewType, setViewType] = useState<"active" | "past">("active");
  
  const filteredLoans = useMemo(() => 
    loans.filter(loan => 
      (searchQuery === "" || 
       loan.instrumentType.toLowerCase().includes(searchQuery.toLowerCase()) || 
       loan.lender.toLowerCase().includes(searchQuery.toLowerCase())) &&
      (statusFilter === "all" || loan.status.toLowerCase() === statusFilter.toLowerCase()) &&
      (typeFilter === "all" || loan.instrumentType.toLowerCase().includes(typeFilter.toLowerCase())) &&
      (viewType === "active" ? loan.status === "Active" : loan.status === "Closed")
    ), 
    [loans, searchQuery, statusFilter, typeFilter, viewType]
  );
  
  return {
    searchQuery,
    setSearchQuery,
    statusFilter,
    setStatusFilter,
    typeFilter,
    setTypeFilter,
    viewType,
    setViewType,
    filteredLoans
  };
};
